import { render, staticRenderFns } from "./ElementExpectationAboveTableColumn.vue?vue&type=template&id=4e0a4f27&scoped=true"
import script from "./ElementExpectationAboveTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementExpectationAboveTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementExpectationAboveTableColumn.vue?vue&type=style&index=0&id=4e0a4f27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a4f27",
  null
  
)

export default component.exports